import a from "./_getNative.js";
import r from "./_root.js";
var t = a, o = r, e = t(o, "Map"), i = e;
export {
  i as default
};
//# sourceMappingURL=_Map.js.map
